export default "__VITE_ASSET__1_pyI6F2__"